import { render, staticRenderFns } from "./RuleConfig.vue?vue&type=template&id=3d751cae&scoped=true"
import script from "./RuleConfig.vue?vue&type=script&lang=js"
export * from "./RuleConfig.vue?vue&type=script&lang=js"
import style0 from "./RuleConfig.vue?vue&type=style&index=0&id=3d751cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d751cae",
  null
  
)

export default component.exports